import React, { useEffect, useState } from "react";
import { FxLabel } from "./FxLabel";

export const FxEmail = props => {
  const { attr, onChangeValue, fxInObj, inputType } = props;
  const defaultValue = fxInObj[attr.attrName];
  const disabled = attr.readOnlyYn === 'Y';
  const sx = {};

  if (attr.uiWidth > 0) {
    sx.minWidth = attr.uiWidth;
    sx.width = attr.uiWidth;
  } else {
    sx.width = '100%';
  }

  function onChange(event) {
    onChangeValue(event.target.id, event.target.value);
  }

  console.log('*** FxEmail ***', inputType, attr.attrName, fxInObj[attr.attrName]);

  return (
    <>
      <FxLabel attr={attr} inputType={inputType} />
      <input className="FxTextField" type="email" id={attr.attrName} style={sx} defaultValue={defaultValue} disabled={disabled}
        onChange={onChange} />
    </>
  );

}
